module.exports = __webpack_public_path__ + "img/user_active.ec84e48d.svg";